module.exports = __webpack_public_path__ + "img/P150T_weapon_117.e8f8be51.png";